'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = require('../../actions/action-types');

var theatreReducer = function theatreReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.THEATRE_CLOSE:
      // Clear all theatre properties such as recommendations
      // - Rely on browser caching to streamline requests for the same theatre id as previously selected
      return {
        feedContentId: null,
        isMiniProfile: false
      };
    case _actionTypes.THEATRE_OPEN:
      return _extends({}, state, {
        feedContentId: action.feedContentId,
        isMiniProfile: action.isMiniProfile
      });
    case _actionTypes.THEATRE_RECEIVE_RECOMMENDED_VIDEOS:
      var oldRecommendations = state.recommendations || [];
      return _extends({}, state, {
        recommendations: [].concat(oldRecommendations, action.recommendations)
      });
    case _actionTypes.THEATRE_SELECT_RECOMMENDATION:
      return _extends({}, state, {
        selectedRecommendation: action.communityContentId
      });
    case _actionTypes.THEATRE_SHARE_RECOMMENDATION:
      return _extends({}, state, {
        sharedRecommendation: action.communityContentId
      });
    default:
      return state;
  }
};

exports.default = theatreReducer;